import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const CTASection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('ctaTitle')}</h2>
        <p className="text-lg text-gray-600 mb-4">{t('ctaSubtitle')}</p>
        <div className="bg-gradient-to-r from-blue-50 to-emerald-50 border border-blue-200 rounded-lg p-6 mb-8">
          <div className="grid md:grid-cols-2 gap-6 text-left">
            <div>
              <h3 className={`font-semibold text-blue-800 mb-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? '🎯 دقة واتساق' : '🎯 Accuracy & Consistency'}
              </h3>
              <p className={`text-gray-700 text-sm ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? 'دقة لا مثيل لها مصممة خصيصاً لقوانين البناء في دول مجلس التعاون الخليجي والشرق الأوسط' : 'Unparalleled precision tailored to GCC and Middle Eastern construction laws'}
              </p>
            </div>
            <div>
              <h3 className={`font-semibold text-blue-800 mb-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? '🤝 شفافية' : '🤝 Transparency'}
              </h3>
              <p className={`text-gray-700 text-sm ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? 'الذكاء الاصطناعي يعزز الخبرة البشرية، لا يحل محلها' : 'AI augments human expertise, doesn\'t replace it'}
              </p>
            </div>
          </div>
        </div>
        <div className={`flex justify-center`}>
          <Link to="/signup" className="px-8 py-4 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition shadow-lg text-lg">
            {isRTL ? 'ابدأ تجربتك المجانية' : 'Start Your Free Trial'}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
